import { AgendaService } from './../../../agenda/shared/services/agenda.service';
import { Component, OnInit, Input } from '@angular/core';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';
import { TypeRendezVous } from '../../../agenda/shared/classes/type-rendez-vous';
import { FormControl } from '@angular/forms';
import { imgCardDrop } from '../../classes/animations';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';

@Component({
    selector: 'app-admin-list-type-rdv',
    templateUrl: './admin-list-type-rdv.component.html',
    styleUrls: ['./admin-list-type-rdv.component.css'],
    animations: [imgCardDrop]
})
export class AdminListTypeRdvComponent implements OnInit {

    aclConfig: AclAccess;
    typesRdv: TypeRendezVous[];
    selected = new FormControl(0);
    newTypeRdv = new TypeRendezVous();

    @Input()
    triggerReload: () => void;

    constructor(
        private storageService: StorageService,
        private agendaService: AgendaService,
        private alertService: AlertService
    ) { }

    ngOnInit() {
        this.typesRdv = [];
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
    }


    getTypesRdv() {
        this.typesRdv = [];
        this.agendaService.getTypesRdv()
        .subscribe(retour => {
            if (retour.status === 200) {
                retour.data.forEach(element => {
                    this.typesRdv.push(new TypeRendezVous(element));
                });
            }
        });
    }

    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getTypesRdv();
        }
    }


    insertTypeRdv(trv: TypeRendezVous) {
        this.agendaService.insertTypeRdv(trv)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.newTypeRdv = new TypeRendezVous();
                this.alertService.success(TRANSLATE('Type ajouté avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    updateTypeRdv(trv: TypeRendezVous) {
        this.agendaService.updateTypeRdv(trv.trv_id, trv)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Type modifié avec succès'));
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

    deleteTypeRdv(trv: TypeRendezVous) {
        this.agendaService.deleteTypeRdv(trv.trv_id)
        .subscribe(retour => {
            if (retour.status === 200) {
                this.alertService.success(TRANSLATE('Type supprimée avec succès'));
                this.getTypesRdv();
                if (this.triggerReload) {
                    this.triggerReload();
                }
            } else {
                this.alertService.error(TRANSLATE(retour.message));
            }
        });
    }

}
